<div class="dialog">
    <h2 class="dialog__title">Change your stay in {{ data.cityName }}</h2>

    <div class="dialog__content">
        <p class="content-title">What about your trip duration?</p>
        @if (data.isOptimizedMode) {
            <div class="adjust-options">
                <button [class.option-selected]="!maintainDuration" (click)="onMaintainDurationHandler(false)">
                    Change trip duration <br/> accordingly
                </button>
                <button [class.option-selected]="maintainDuration" (click)="onMaintainDurationHandler(true)">
                    Keep trip duration <br/> {{ data.numDays }} days
                </button>
            </div>
            <div class="dialog__checkbox">
                <mat-checkbox [(ngModel)]="saveSelectedOption" (change)="onSaveSelectedOptionHandler()">
                    <span>Use this settings for all my next edits</span>
                </mat-checkbox>
            </div>
        }

        @if (!maintainDuration) {
            <div class="dialog__notice-info">
                <p>Your trip duration is {{ changedDurationText }}</p>
                @if (data.newEndDate) {
                    <p>New return date: {{ data.newEndDate }}</p>
                }
            </div>
        }
    </div>

    @if (data.isOptimizedMode) {
        <p class="dialog__description">
            Routeperfect's experts will optimize your route to adjust it to your change.
            <br/>
            You can cancel the optimization process by turning RoutePerfect optimizer off.
        </p>
    }

    <div class="dialog__actions">
        <button
                class="dialog__button dialog__button--cancel"
                (click)="closeModal({res: false, maintain: false})"
        >
            Cancel
        </button>
        <button
                class="dialog__button dialog__button--confirm"
                (click)="closeModal({res: true, maintain: maintainDuration})"
        >
            Change
        </button>
    </div>
</div>
